/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fair_Tame_Buck_AidInputs */

const en_fair_tame_buck_aid = /** @type {(inputs: Fair_Tame_Buck_AidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The results for this peer feedback are not available yet. Please try again shortly.`)
};

const de_fair_tame_buck_aid = /** @type {(inputs: Fair_Tame_Buck_AidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Ergebnisse für dieses Peer-Feedback stehen noch nicht zur Verfügung. Bitte versuche es in Kürze erneut.`)
};

/**
* | output |
* | --- |
* | "The results for this peer feedback are not available yet. Please try again shortly." |
*
* @param {Fair_Tame_Buck_AidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fair_tame_buck_aid = /** @type {((inputs?: Fair_Tame_Buck_AidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_Tame_Buck_AidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fair_tame_buck_aid(inputs)
	return de_fair_tame_buck_aid(inputs)
});